import { z } from 'zod';
export const INPUT_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
export const MAX_INPUT_IMAGE_BYTES = 20 * 1024 * 1024;
/** A picture in the machine's ComfyUI input folder; `name` is what LoadImage.image takes (doc 33). */
export const InputImageSchema = z.object({ name: z.string(), url: z.string() });
export const InputImageResponseSchema = z.object({ image: InputImageSchema });
export const InputImagesResponseSchema = z.object({ images: z.array(InputImageSchema) });
//# sourceMappingURL=inputs.js.map